module.exports = __webpack_public_path__ + "public/1.0.1_200686/img/ja-4.97482ad8.png";